var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgCrossIcon = function SvgCrossIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#crossIcon_svg__clip0_6700_587961)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7 1.7L22.3.3 12 10.6 1.7.3.3 1.7 10.6 12 .3 22.3l1.4 1.4L12 13.4l10.3 10.3 1.4-1.4L13.4 12 23.7 1.7z",
    fill: "#333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "crossIcon_svg__clip0_6700_587961"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgCrossIcon;